export class FirmwareUpgradeProgressNotification
{
    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }

    public DeviceDescription: string;
    public DeviceId: number;
    public DeviceType: number;
    public DeviceUId: string;
    public IsFirmwareUpgradeToCommCard: false;
    public PercentComplete: number;
    public StatusCode: number;
    public TypeCode: number;

    get isComplete(): boolean
    {
        return this.PercentComplete && this.PercentComplete === 100;
    }

}
